import { ReactNode } from "react";

import { UseTalkRoomAndMessageCollection } from "../../hooks/useTalkRoomAndMessageCollection";
import { TalkBox, TalkBoxProps } from "../../ui/TalkBox";
import { TalkForm, TalkFormValues } from "../../ui/TalkForm";
import styles from "./index.module.css";

export type TalkMessageListViewProps = Pick<TalkBoxProps, "onVisibleUnreadMessage" | "talkSenderType"> &
  ReturnType<UseTalkRoomAndMessageCollection> & {
    roomId: string;
    onSubmit: (values: TalkFormValues) => void | Promise<void>;
    bottomContent?: ReactNode;
  };

export const TalkMessageListView = ({
  talkSenderType,
  room,
  messages,
  roomId,
  onSubmit,
  onVisibleUnreadMessage,
  bottomContent,
}: TalkMessageListViewProps) => (
  <div className={styles.layout}>
    <div className={styles.content}>
      <TalkBox
        roomId={roomId}
        talkSenderType={talkSenderType}
        room={room}
        messages={messages}
        onVisibleUnreadMessage={onVisibleUnreadMessage}
        bottomContent={bottomContent}
      />
    </div>

    <div className={styles.form}>
      <TalkForm onSubmit={onSubmit} />
    </div>
  </div>
);
